module.exports = __webpack_public_path__ + "img/avatar7.8c866d3c.png";